import { useCallback, useMemo } from 'react';

import { IUseQueryProps } from 'store/queries/types';
import { getQueryParams } from 'store/utils/getQueryParams';
import { useAppSelector } from 'store/useAppSelector';

import {
  IFetchIsOldAccountParams,
  selectIsOldAccount,
  selectIsOldAccountLoading,
  selectIsOldAccountState,
  useFetchIsOldAccountQuery,
  useLazyFetchIsOldAccountQuery,
} from '../fetchIsOldAccount';

export interface IUseIsOldAccountQueryProps
  extends IUseQueryProps,
    IFetchIsOldAccountParams {}

export const useIsOldAccountQuery = ({
  account,
  skipFetching,
}: IUseIsOldAccountQueryProps) => {
  const params = useMemo(
    (): IFetchIsOldAccountParams => ({ account }),
    [account],
  );

  useFetchIsOldAccountQuery(getQueryParams({ params, skipFetching }));

  const [fetchLazy] = useLazyFetchIsOldAccountQuery();

  const handleFetchIsOldAccount = useCallback(
    () => fetchLazy(params),
    [fetchLazy, params],
  );

  const isOldAccount = useAppSelector(state =>
    selectIsOldAccount(state, params),
  );

  const loading = useAppSelector(state =>
    selectIsOldAccountLoading(state, params),
  );

  const state = useAppSelector(storeState =>
    selectIsOldAccountState(storeState, params),
  );

  return { handleFetchIsOldAccount, isOldAccount, loading, params, state };
};
